<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>分站管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>分站管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>分站管理列表</span>
        </div>
        <span class="xcx-add left font14" @click="add()">添加分站</span>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="UID" width="80"></el-table-column>
          <el-table-column prop="username" label="账号"></el-table-column>
          <el-table-column prop="contact" label="联系人" width="120"></el-table-column>
          <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
          <el-table-column label="访问域名" width="260"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="setStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" width="160" label="添加时间"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    add() {
      this.$router.push("/admin/add");
    },
    edit(ids) {
      // this.$router.push({
      //   path: "/goods/add_goods",
      //   query: {
      //     id: ids,
      //   },
      // });
    },
    setIsTop(row) {
      var that = this;
      that.axios
        .post("/Activity/istop", { id: row.id, istop: row.istop })
        .then((res) => {});
    },
    setStatus(row) {
      var that = this;
      that.axios
        .post("/Activity/status", { id: row.id, istop: row.istop })
        .then((res) => {});
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/Users/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      that.axios.post("/Users/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
</style>